'use strict';

angular.module('loginModule')
.directive('jerichoLoginPage', function ()
{
    return {
        restrict: 'E',
        bindToController: {
            onLogin: '&'
        },
        controller: 'LoginCtrl',
        controllerAs: '$ctrl',
        templateUrl: 'login/loginPage.html'
    };
});
